import { Component, inject, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { InputNumberModule } from 'primeng/inputnumber';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorComponent } from '../../../error/error.component';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';

@Component({
  selector: 'app-distance-form',
  imports: [
    TranslocoPipe,
    InputNumberModule,
    ErrorComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './distance-form.component.html',
})
export class DistanceFormComponent implements OnInit {
  transportFormService = inject(TransportFormService);
  ngOnInit() {
    this.transportFormService.createDistanceControls();
  }
}
